<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  created () {
    const hash = window.location.hash // 获取 # 及其后面的内容
    const queryString = hash.includes('?') ? hash.split('?')[1] : '' // 取 ? 号后的部分
    const urlParams = new URLSearchParams(queryString)

    // const urlParams = new URLSearchParams(window.location.search)
    this.token = urlParams.get('token') || ''
    this.version = urlParams.get('x-version') || '1.0.0'
    this.packageName = urlParams.get('x-package-name') || ''
    this.orderNo = urlParams.get('orderNo') || ''
    this.adid = urlParams.get('adid') || ''
    this.userRandomKey = urlParams.get('userRandomKey') || ''
    localStorage.setItem('token', this.token)
    localStorage.setItem('version', this.version)
    localStorage.setItem('packageName', this.packageName)
    localStorage.setItem('orderNo', this.orderNo)
    localStorage.setItem('adid', this.adid)
    localStorage.setItem('userRandomKey', this.userRandomKey)

    // 将URL的path存在sessionStorage中，判断是否为第一次进的页面
    const path = hash.includes('?') ? hash.split('?')[0].replace('#', '') : hash.replace('#', '')
    sessionStorage.setItem('initialPath', path)
  }
}
</script>

<style lang="less">
#app {
  font-family: PingFang, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #39404A;
  background-color: #F6F7FB;
}
</style>
